import React from 'react';
import { Card } from '../components/card/Card';
import { IconMap } from '../lib';

interface SchemesProps {}

const Schemes: React.FC<SchemesProps> = () => {
  const schemes = [
    {
      icon: IconMap.faEuroSign,
      title: "ECCE Programme",
      features: [
        "Provides free early childhood education for children in the year before starting primary school",
        "Focuses on play-based learning to support social, emotional, and cognitive development",
        "Follows the Aistear & Siolta Curriculum Framework, promoting creativity, curiosity, and confidence",
        "Delivered by qualified, experienced early years educators",
        "Offers Morning session to fit family needs",
        "Helps children settle confidently into school, building foundational skills for lifelong learning",
        "Supported by the Irish Government, making early education accessible to all eligible families"
      ],
      badge: "Free",
      badgeType: "free" as const
    },
    {
      icon: IconMap.faGraduationCap,
      title: "Access and Inclusion Model (AIM) Aims",
      features: [
        "Ensure all children have access to early childhood education, regardless of ability or background",
        "Promote inclusive participation for children with additional needs",
        "Provide support and resources to children and their families to fully engage in the ECCE programme",
        "Foster an environment of equality and respect for diversity",
        "Collaborate with parents, educators, and support services to meet individual needs",
        "Help children develop social, emotional, and educational skills alongside their peers",
        "Remove barriers to participation, making early learning accessible for every child"
      ],
      badge: "Inclusive",
      badgeType: "default" as const
    },
    {
      icon: IconMap.faHeart,
      title: "NCS (National Childcare Scheme)",
      features: [
        "Provides financial support to help families with the cost of childcare",
        "Available for children from 2 years 8 Months up to 12 Years",
        "Supports preschool, after-school",
        "Helps make quality childcare more affordable and accessible for all families",
        "Funding is based on household income and childcare hours",
        "Administered by the Irish Government and integrates with approved childcare providers",
        "Aims to support children's learning, development, and wellbeing while easing the financial burden on families"
      ],
      badge: "Subsidized",
      badgeType: "subsidized" as const
    }
  ];

  return (
    <div className="bg-[#fff9e6]">
    <section className="py-16" id="schemes">
      <div className="body-container py-16 pt-0 px-4 sm:px-6 lg:px-8">
        <div className="section-header" data-aos="fade-up">
          <button className="button-offer">Schemes</button>
          <p className="section-subtitle">
            We participate in various government and community childcare schemes to make quality
            childcare accessible and affordable for all families in our community.
          </p>
        </div>
        
        <div className="schemes-grid">
          {schemes.map((scheme, index) => (
            <Card
              key={index}
              icon={scheme.icon}
              title={scheme.title}
              // description={scheme.description}
              features={scheme.features}
              badge={scheme.badge}
              badgeType={scheme.badgeType}
            />
          ))}
        </div>
      </div>
    </section>
    </div>
  );
};

export default Schemes; 